export const getFirstSymbol = (name: string): string => {
  const trimmedName = name.trim();
  const emojiRegex =
    /^(\p{Emoji_Presentation}|\p{Emoji}\uFE0F|\p{Emoji_Modifier_Base}\p{Emoji_Modifier}?)/u;
  const match = trimmedName.match(emojiRegex);
  return match ? match[0] : trimmedName.charAt(0);
};
